function generateBearer(tokenBody: AccessTokenBody): BearerToken {
  return `Bearer ${tokenBody}` as BearerToken;
}

export { generateBearer };
